// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReconcileView-module_date_box_OvMEV {
  display: inline-flex;
}

.ReconcileView-module_clear_edit_date_button_IDguK {
  min-height: 16px !important;
  min-width: 16px !important;
  padding: 0 !important;
}

.ReconcileView-module_edit_button_rntHK {
  border-radius: 16px !important;
  margin-bottom: 4px;
}

.ReconcileView-module_edit_button_white_qduZV {
  background-color: #f6f7f9 !important;
}

.ReconcileView-module_edit_button_white_qduZV:hover {
  background-color: #f6f7f9 !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Transactions/ReconcileView.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EAEE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".date_box {\n  display: inline-flex;\n}\n\n.clear_edit_date_button {\n  min-height: 16px !important;\n  min-width: 16px !important;\n  padding: 0 !important;\n}\n\n.edit_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n  border-radius: 16px !important;\n  margin-bottom: 4px;\n}\n\n.edit_button_white {\n  composes: edit_button;\n  background-color: #f6f7f9 !important;\n}\n\n.edit_button_white:hover {\n  background-color: #f6f7f9 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date_box": `ReconcileView-module_date_box_OvMEV`,
	"clear_edit_date_button": `ReconcileView-module_clear_edit_date_button_IDguK`,
	"edit_button": `ReconcileView-module_edit_button_rntHK ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"edit_button_white": `ReconcileView-module_edit_button_white_qduZV ReconcileView-module_edit_button_rntHK ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`
};
export default ___CSS_LOADER_EXPORT___;
